import React from "react"

const CurveSlider = ({ register, curveFormName, watch }) => (
  <div>
    <label htmlFor="curveSlider">ความโค้งขอบรูปภาพ:</label>
    <input
      type="range"
      id="curveSlider"
      defaultValue={0}
      min={0}
      max={100}
      name={curveFormName}
      ref={register}
    />
    <span>{watch(curveFormName)}%</span>
  </div>
)

export default CurveSlider
